module.exports = "/packs/images/icons/icon-book-55049cd45bc2a0f6e8c603e929064d24.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icons/icon-book.png
// module id = 1790
// module chunks = 0